import { render, staticRenderFns } from "./SloganSection.vue?vue&type=template&id=5eddc6e0&scoped=true&lang=html&"
import script from "./SloganSection.vue?vue&type=script&lang=js&"
export * from "./SloganSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eddc6e0",
  null
  
)

export default component.exports